let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ls0Um")).then(() => parcelRequire('90Icb'));